import { getCurrentInstance, onMounted, ref, type Ref } from 'vue'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'theme'
const isDark = ref(false)

export function useTheme(): {
  isDark: Ref<boolean>
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
} {
  function loadTheme(): void {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'dark') {
      isDark.value = true
      document.documentElement.classList.add('dark')
    } else {
      isDark.value = false
      document.documentElement.classList.remove('dark')
    }
  }

  function setTheme(theme: Theme): void {
    isDark.value = theme === 'dark'
    if (isDark.value) {
      document.documentElement.classList.add('dark')
      localStorage.setItem(STORAGE_KEY, 'dark')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem(STORAGE_KEY, 'light')
    }
  }

  function toggleTheme(): void {
    setTheme(isDark.value ? 'light' : 'dark')
  }

  if (getCurrentInstance()) {
    onMounted(() => {
      loadTheme()
    })
  }

  return {
    isDark,
    setTheme,
    toggleTheme,
  }
}
